<template>
  <listing-layout :actionBar="true">
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="h2 mb-0">Expression Of Interest</h1>
    </div>

    <div slot="content">

      <div role="alert" class="alert alert-success mt-3" v-if="success !== ''">{{ success }}</div>
      <div role="alert" class="alert alert-warning mt-3" v-else-if="errors !== ''">{{ errors }}</div>

      <div class="expression-interest" v-if="loaded">
        <div class="drafts" v-if="drafts.length > 0">
          <div class="draft" v-for="draft in drafts" :key="draft.id">
            <div class="draft_header table table-bordered p-3 bg-lighter justify-content-between align-items-center d-flex">
              <div class="draft-info">
                <div class="d-flex flex-wrap align-content-center">
                  <h2 class="h5 mr-2">
                    {{ draft.name }}
                  </h2>
                </div>

                <div class="dates d-flex">
                  <div class="start_date mr-3">
                    <span class="font-weight-bolder">Start Date: </span> {{ draft.start_date }}
                  </div>
                  <div class="finish_date">
                    <span class="font-weight-bolder">Finish Date: </span> {{ draft.end_date }}
                  </div>
                </div>
              </div>
              <button
                class="btn-default btn-small btn btn-sm btn-primary btn-cancel_application"
                v-on:click="takeInterest(draft.id, judgeId)"
              >Submit</button>
            </div>
          </div>
        </div>
        <div v-else class="alert alert-warning rounded-0 mb-0">There are no results.</div>
      </div>
      <div class="bg-white rounded mb-4 p-3 p-sm-4 flex-grow-1 mr-lg-3" v-else>
        <div class="text-center p-2">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </listing-layout>
</template>

<script>
import listingLayout from '@/components/ListingLayout'
import axios from "axios"

export default {
  components: {
    'listing-layout': listingLayout
  },
  name: "ExpressionInterest",
  data() {
    return {
      success: '',
      errors: '',
      loaded: false,
      drafts: [],
      judgeId: null
    }
  },
  mounted() {
    this.judgeId = this.$route.params.slug

    if (!this.judgeId) {
      this.$router.push({ name: 'Judges Dashboard' })
    }

    axios.get(`${this.$api}/judges/${this.judgeId}/published-drafts`).then((response) => {
      if (response.data.status === 'success') {
        this.errors = ''
        this.drafts = response.data.data
        this.loaded = true
      } else if (response.data.status === 'forbidden') {
        this.$router.push({ name: 'Judges Dashboard' })
      } else {
        this.errors = 'Unable to receive data from the server. Please reload the page.'
      }
    })
  },
  methods: {
    takeInterest(draftId, judgeId) {
      const formData = new FormData()

      formData.append('fields', JSON.stringify({
        draft_id: draftId
      }))

      axios.post(`${this.$api}/judges/${judgeId}/drafts/application`, formData).then((response) => {
        if (response.data.status === 'success') {
          // Done
          this.success = 'The draft has been submitted.'
          this.errors = ''
          location.reload()
        } else if (response.data.status === 'application_exists') {
          this.success = ''
          this.errors = 'The application is not unique.'
        } else if (response.data.status === 'invalid_user' && response.data.errors) {
          this.success = ''
          this.errors = 'The user is not the judge'
        } else if (response.data.status === 'judge_is_suspended' && response.data.errors) {
          this.success = ''
          this.errors = 'The judge is suspended'
        } else if (response.data.status === 'unfinancial_user' && response.data.errors) {
          this.success = ''
          this.errors = 'Please pay a subscription for a judge'
        } else {
          this.success = ''
          this.errors = 'Something went wrong. Please try again later.'
        }
      }).catch(() => {
        this.success = ''
        this.errors = 'There was a server error. Please try again later.'
      })
    }
  }
}
</script>

<style>
.expression-interest .btn-cancel_application {
  max-width: 110px;
  min-width: 80px;
}

@media (max-width: 767px) {

  .expression-interest .draft_header {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .expression-interest .draft-info {
    margin-bottom: 6px;
  }
}

@media (max-width: 550px) {

  .expression-interest .draft-info .dates {
    flex-direction: column;
    align-items: flex-start !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Judges/ExpressionOfInterest/ExpressionInterest.vue